export default __webpack_public_path__ + "static/media/indicator-icon.1e56d70b.svg";